import { Injectable } from '@angular/core';
import {
  Router, Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { Observable, of } from 'rxjs';
import {CoreService} from "../services/core.service";
import {PageNumber, PageSize} from "../shared/variables/variables";

@Injectable({
  providedIn: 'root'
})
export class DoorsResolver implements Resolve<boolean> {
  constructor(private coreService: CoreService) {
  }

  resolve(): Observable<any> {
    return this.coreService.getRequest(`admin/getDoor?limit=${PageSize}&page=${PageNumber}`);
  }
}
